<template>
    <transition name="dialogfade">
        <k-dialog v-if="showDialog"
                  class="edit-condition-dialog enc-lock-warning-dialog"
                  :title="dialogTitle"
                  @close="closeDialog">
            <p class="lock-warning-msg">{{ dialogMsg }}</p>
            <p class="lock-warning-info">{{dialogInfo }}</p>
        </k-dialog>
    </transition>
</template>

<script>
    import { Dialog } from '@progress/kendo-vue-dialogs'; 

    export default {
        props: ['showDialog'],
        emits: ['dialogclosed'],
        data() {
            return {
                dialogTitle: 'Loan Lock Warning',
                dialogInfo: 'Close the loan in Encompass to restore full functionality',
                dialogMsg: 'This loan is currently locked in Encompass, which limits the availability of Swift functionality and features'
            }
        },
        methods: {
            closeDialog() {
                this.$emit('dialogclosed');
            }
        },
        components: {
            'k-dialog': Dialog
        }
    }
</script>

<style>
    @import '/src/assets/css/encLockWarningDialog.css';
</style>